<template>
  <div id="layout">
    <!-- <div class="layout" :style="wrapperStyle"> -->
    <div class="layout">
      <defaultHeader/>
      <appMain/>
      <defaultFooter/>
    </div>
  </div>
</template>

<script>
// 组件
import defaultHeader from "@/components/defaultHeader";
import defaultFooter from "@/components/defaultFooter"
import appMain from "@/components/appMain";


import { getZoomLevel } from '@/utils/index.js';
import { debounce } from 'lodash';

export default {
  name: 'layoutIndex',
  components: {
    defaultHeader,
    defaultFooter,
    appMain
  },
  data(){
    return {
      zoomLevel: 1
    }
  },
  computed: {
    wrapperStyle() {
      const scale = 1 / this.zoomLevel;
      return {
        transform: `scale(${scale})`,
        transformOrigin: 'top left'
      };
    }
  },
  mounted() {
    this.updateZoomLevel();
    this.debouncedUpdate = debounce(this.updateZoomLevel, 100);
    window.addEventListener('resize', this.debouncedUpdate);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedUpdate);
  },
  methods: {
    updateZoomLevel() {
      this.zoomLevel = getZoomLevel();
    }
  }
}
</script>

<style>
.layout{
  /* overflow-x: hidden; */
  /* min-width: 1920px; */
}
</style>